import {
  Activity,
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowLeft,
  ArrowRight,
  BarChart,
  Bed,
  Bell,
  BookOpen,
  Briefcase,
  Building,
  Building2,
  Calendar,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ClipboardList,
  Clock,
  Construction,
  Cross,
  Cpu,
  Database,
  DollarSign,
  DoorOpen,
  Edit,
  FileSearch,
  FileText,
  Folder,
  FolderOpen,
  Globe,
  GraduationCap,
  HardDrive,
  Hash,
  History,
  Home,
  Inbox,
  Info,
  Key,
  LayoutDashboard,
  Loader2,
  Lock,
  LogOut,
  Mail,
  Megaphone,
  Menu,
  MessageCircle,
  MessageSquare,
  Monitor,
  Moon,
  Newspaper,
  Package,
  Phone,
  PhoneCall,
  Plus,
  RefreshCw,
  RotateCcw,
  Save,
  ScanLine,
  Search,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShoppingCart,
  Star,
  Stethoscope,
  Sun,
  Trash2,
  User,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserX,
  Users,
  Wrench,
  X,
} from 'lucide-react';

export const icons = {
  Activity,
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowLeft,
  ArrowRight,
  BarChart,
  Bed,
  Bell,
  BookOpen,
  Briefcase,
  Building,
  Building2,
  Calendar,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ClipboardList,
  Clock,
  Construction,
  Cross,
  Cpu,
  Database,
  DollarSign,
  DoorOpen,
  Edit,
  FileSearch,
  FileText,
  Folder,
  FolderOpen,
  Globe,
  GraduationCap,
  HardDrive,
  Hash,
  History,
  Home,
  Inbox,
  Info,
  Key,
  LayoutDashboard,
  Loader2,
  Lock,
  LogOut,
  Mail,
  Megaphone,
  Menu,
  MessageCircle,
  MessageSquare,
  Monitor,
  Moon,
  Newspaper,
  Package,
  Phone,
  PhoneCall,
  Plus,
  RefreshCw,
  RotateCcw,
  Save,
  ScanLine,
  Search,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShoppingCart,
  Star,
  Stethoscope,
  Sun,
  Trash2,
  User,
  UserCheck,
  UserCog,
  UserMinus,
  UserPlus,
  UserX,
  Users,
  Wrench,
  X,
};